var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Layout',{staticClass:"bg-white",attrs:{"navFixed":true,"withImage":false,"hideCart":"true","hideMenu":"true","hideFooter":"true"}},[_c('Checkout')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }